import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { ListRow } from 'basic-components';
import { Info, Remove } from 'basic-components/icons';

import { creatorCurvesActions } from 'actions/curves';

const Row = ({ scrollRef, groupName, product, root, index, setSelectedSymbolIndex, swapIsInfoModalOpen }) => {
  const dispatch = useDispatch(),
        removeItem = useCallback(() => dispatch(creatorCurvesActions.removeCurve(index)), [dispatch, index]),
        openModal = useCallback(() => {
          setSelectedSymbolIndex(index)
          swapIsInfoModalOpen()
        }, [index, setSelectedSymbolIndex, swapIsInfoModalOpen]),
        handleOnInfoKeyDown = useCallback(e => {
          if ((e.key === "Enter" || e.key === " ")) {
            e.preventDefault()
            openModal()
          }
        }, [openModal]),
        handleOnRmoveKeyDown = useCallback(e => {
          if ((e.key === "Enter" || e.key === " ")) {
            e.preventDefault()
            removeItem()
          }
        }, [removeItem])

  return (
    <ListRow
        className={"ng-office-app__authed__content__basket__body__data__basket__items__item"}
        offset={8000}
        scrollContRef={scrollRef}
    >
      <div
          aria-label={`Open ${root} info modal`}
          className="ng-office-app__authed__content__basket__body__data__basket__items__item__info"
          onClick={openModal}
          onKeyDown={handleOnInfoKeyDown}
          role="button"
          tabIndex={0}
      >
        <Info
            color="blue-bright"
            height={16}
            width={16}
        />
      </div>
      <div className="ng-office-app__authed__content__basket__body__data__basket__items__item__cell">
        {groupName}
      </div>
      <div className="ng-office-app__authed__content__basket__body__data__basket__items__item__cell">
        {root}
      </div>
      <div
          aria-label={`Remove ${groupName} ${product} ${root}`}
          className="ng-office-app__authed__content__basket__body__data__basket__items__item__action"
          onClick={removeItem}
          onKeyDown={handleOnRmoveKeyDown}
          role="button"
          tabIndex={0}
      >
        <Remove
            color="red-dark"
            height={16}
            width={16}
        />
      </div>
    </ListRow>
  )
}

Row.propTypes = {
  groupName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  product: PropTypes.string.isRequired,
  root: PropTypes.string.isRequired,
  scrollRef: PropTypes.any.isRequired,
  setSelectedSymbolIndex: PropTypes.func.isRequired,
  swapIsInfoModalOpen: PropTypes.func.isRequired,
}

export default Row;